var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        {
          attrs: {
            flat: _vm.flat,
            dense: _vm.dense,
            dark: !_vm.light,
            color: _vm.color ? _vm.color : "secondary",
          },
        },
        [
          _vm._t("title", function () {
            return [
              _c("v-toolbar-title", {
                domProps: { innerHTML: _vm._s(_vm.title) },
              }),
            ]
          }),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.search
            ? _c(
                "v-text-field",
                _vm._g(
                  {
                    staticClass: "mt-2 emphasize-clear",
                    class: { rounded: _vm.rounded },
                    attrs: {
                      dark: !_vm.lightSearch,
                      "append-icon": "search",
                      label: `Search ${
                        _vm.search ? _vm.search.toLowerCase() : ""
                      }`,
                      autofocus: "",
                      clearable: "",
                      value: _vm.value,
                      loading: _vm.loading,
                      color: _vm.lightSearch ? "" : "white",
                      hint: _vm.hint,
                      solo: "",
                    },
                    on: {
                      "click:clear": function ($event) {
                        return _vm.clearSearch()
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm.$slots.tooltip
                          ? {
                              key: "append",
                              fn: function () {
                                return [
                                  _vm._t("tooltip"),
                                  _vm._v(" "),
                                  _c("v-icon", { staticClass: "ml-2" }, [
                                    _vm._v("search"),
                                  ]),
                                ]
                              },
                              proxy: true,
                            }
                          : null,
                      ],
                      null,
                      true
                    ),
                  },
                  _vm.$listeners
                )
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("actions"),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.$slots.default
            ? _c(
                "v-toolbar",
                {
                  attrs: {
                    flat: _vm.flat,
                    dark: "",
                    color: _vm.secondaryColor ? _vm.secondaryColor : "tertiary",
                    dense: "",
                  },
                },
                [_vm._t("default")],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }